import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const api = axios.create({
  baseURL: BASE + "/api",
  timeout: 15000,
});

const TOKEN_KEY = "magicdil_token";
const USER_KEY = "magicdil_user";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const userStore = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
  set: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
};

api.interceptors.request.use((cfg) => {
  const tk = tokenStore.get();
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
      const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
      const loginPath = base + "/login";
      if (!window.location.pathname.startsWith(loginPath)) {
        window.location.href = loginPath + "?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return iso;
  }
};

// Normalise FastAPI / Pydantic error responses into a single readable string.
export const errMessage = (err, fallback = "Something went wrong") => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => d?.msg || d?.message || JSON.stringify(d))
      .join(", ");
  }
  if (typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return fallback;
};
